import '../../css/base.css';
import BeinnSgritheall from './beinnSgritheall';
import Knoydart from './knoydart';
import Kintail from './kintail';
import WalkHighlands from './walkhighlands';

const Mountains = () => {

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <BeinnSgritheall />
      </div>
      <div className="col-12 col-md-6">
        <Knoydart />
      </div>
      <div className="col-12 col-md-6">
        <Kintail />
      </div>
      <div className="col-12 col-md-6">
        <WalkHighlands />
      </div>
    </div>
  );
}

export default Mountains;